export default __webpack_public_path__ + "static/media/rail-bridge-testing.f9128e13.JPG";